const registerButtons = document.querySelectorAll('.register-buttons__card a');
if (registerButtons.length) {
    registerButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
    
            const registerButtonsBox = document.querySelector('.register__buttons__box');
            const registerNewUser = document.querySelector('.register__new-user');
            const login = document.querySelector('.register__login');
            
            if ( registerNewUser && login ) {
                if ( button.id == "new-user" ){
                    registerNewUser.style.display = 'block';
                    login.remove();
                } else {
                    login.style.display = 'block';
                    registerNewUser.remove();

                    const registerTitle = document.getElementById("regiter-page-title");
                    if( registerTitle )
                        registerTitle.innerHTML = `<h1>Logg inn</h1>`;
                }
            }
            
            registerButtonsBox.remove();
        });
    });
}

const logoutBtn = document.querySelector(".button--logout");
if (logoutBtn) {
    logoutBtn.addEventListener("click", async (e) => {
        e.preventDefault();

        if (logoutBtn.classList.contains('is-disabled')) return;

        // Lock button + show spinner
        logoutBtn.classList.add('is-disabled', 'is-loading');

        // Force paint before fetch
        await new Promise(requestAnimationFrame);

        try {

            const response = await fetch('/event-manager/logout', { method: 'GET' });
            const data = await response.json();

            if( data.success ) {
                setTimeout(() => {
                    window.location.href = "/arrangementer";
                }, 150);
                return;
            }

        } catch( error ) {
            console.log("Error during logout: ", error);
            alert("Logout has failed. Please try again.");
        }

        // Re-enable button on failure
        loginBtn.classList.remove('is-disabled', 'is-loading');
    });
}